
import Vue from 'vue';
import { ModalTitle, Loading } from '@descomplica/vue-components';

export default Vue.extend({
  components: {
    ModalTitle,
    Loading,
  },
});
